import type { WhatsAppTemplate } from '@/types/whatsapp-template';
import { extractTemplateVariables } from './preview-body';

const CUSTOMER_NAME_KEYS = new Set([
  'customer_name',
  'customername',
  'name',
  'first_name',
  'firstname',
  'recipient_name',
]);

export function isCustomerNameVariable(name: string) {
  const normalized = name.toLowerCase().replace(/[\s-]+/g, '_');
  return CUSTOMER_NAME_KEYS.has(normalized);
}

export function getTemplateVariableNames(template: WhatsAppTemplate): string[] {
  if (template.variables?.length) {
    return template.variables;
  }

  return extractTemplateVariables(
    template.body,
    template.footer,
    template.header?.text as string | undefined
  );
}

export function buildTemplateVariableDefaults(
  template: WhatsAppTemplate,
  customerName?: string
): Record<string, string> {
  const names = getTemplateVariableNames(template);
  const resolvedName = customerName?.trim() ?? '';
  const values: Record<string, string> = {};

  for (const name of names) {
    if (isCustomerNameVariable(name) && resolvedName) {
      values[name] = resolvedName;
    } else {
      values[name] = '';
    }
  }

  return values;
}

export function applyCustomerNameToTemplateVariables(
  variableNames: string[],
  variables: Record<string, string>,
  customerName?: string
): Record<string, string> {
  const resolvedName = customerName?.trim();
  if (!resolvedName) return variables;

  const result = { ...variables };

  for (const name of variableNames) {
    if (isCustomerNameVariable(name) && !result[name]?.trim()) {
      result[name] = resolvedName;
    }
  }

  return result;
}
